var _defs, _ellipse, _polygon, _polyline, _polyline2, _polyline3, _line, _line2, _polyline4, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 53.72,
    cy: 54.78,
    rx: 32.23,
    ry: 49.58
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "53.72 5.2 63.23 19.7 71.92 54.78 77.21 67.24 76.97 89.11 63.1 89.96 53.72 104.36 43.84 90.03 30 88.34 30 67.04 21.49 54.78 30.45 42.3 30.21 20.87 43.84 19.38 53.72 5.2"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "40.01 9.9 43.84 19.38 53.72 26.43 67.16 35.57 76.68 42.56 85.94 55.09 77.21 67.24 66.56 74.36 53.72 83.11 43.84 90.03 40.01 99.66"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "67.43 99.66 63.1 89.96 66.8 74.2 71.92 54.78 76.68 42.56 76.99 20.48 63.23 19.7 30.45 42.3 35.48 54.78 40.38 74.03 43.84 90.03"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "23.18 70.63 30 67.37 35.48 54.78 40.63 35.28 43.84 19.38 63.23 19.7 67.43 9.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 84.14,
    y1: 38.36,
    x2: 76.68,
    y2: 42.56
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 84.11,
    y1: 71.32,
    x2: 77.21,
    y2: 67.24
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "63.1 89.96 53.72 83.11 40.38 74.03 30 67.37"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 30.45,
    y1: 42.3,
    x2: 23.18,
    y2: 38.93
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/oval.acf47a0892814b3ebc27a48bf006dfde.svg";
export { ForwardRef as ReactComponent };